(function () {
  function removeLegacyTrustCard() {
    var roots = document.querySelectorAll('.product__info-container, .product__column-sticky, .product');
    if (!roots.length) return;

    var legacyPhrases = [
      'HOW WE STAND BEHIND EVERY MASK',
      'How we stand behind every mask',
      '30 nights to decide',
      'full refund if not'
    ];

    roots.forEach(function (root) {
      var candidates = root.querySelectorAll('section, div');
      candidates.forEach(function (node) {
        if (!node || node.classList.contains('dr-pdp-proof') || node.querySelector('.dr-pdp-proof')) return;
        var text = (node.textContent || '').trim();
        if (!text) return;
        var isLegacy = legacyPhrases.some(function (phrase) {
          return text.indexOf(phrase) !== -1;
        });
        if (!isLegacy) return;
        node.remove();
      });
    });
  }

  function positionTrustProofAboveCta() {
    document.querySelectorAll('.product__info-container, .product__column-sticky, .product').forEach(function (root) {
      var proof = root.querySelector('.dr-pdp-proof');
      var buttons = root.querySelector('.product-form__buttons');
      if (!proof || !buttons) return;
      var productForm = buttons.closest('product-form') || buttons.closest('form') || buttons.parentElement;
      if (!productForm || productForm.previousElementSibling === proof) return;
      productForm.parentNode.insertBefore(proof, productForm);
    });
  }

  function run() {
    removeLegacyTrustCard();
    positionTrustProofAboveCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  setTimeout(run, 500);
  setTimeout(run, 1500);
  window.addEventListener('shopify:section:load', run);
})();
